export default __webpack_public_path__ + "static/media/Shuflic2.723e0c3f.mp4";